<template>
  <div class="login">
    <div class="login-center">
      <div class="book">
        <img src="../assets/book.jpg" />
      </div>
      <div class="right">
        <div class="qrcode">
          <el-image v-if="qrcode != null" :src="qrcode"></el-image>
          <div v-if="status != 0" v-on:click="getQrCode" class="message-box">
            <div class="in-message-box">
              <div>{{message}}</div>
              <span>点击刷新</span><i class="el-icon-refresh"></i>
            </div>
          </div>
        </div>
        <div class="link">请使用汤圆记账APP扫码登录 <a href="https://tangyuanjizhang.com/upload/tangyuanjizhang.apk">点击下载</a></div>
      </div>
    </div>
  </div>
</template>

<script>
import {WhiteList} from '../const/const'

export default {
  name: 'Login',
  components: {
  },
  data() {
    return {
      interval: null,
      code: null,
      qrcode: null,
      status: 0,
      message: "",
      verifying: false,
    }
  },
  mounted() {
    this.getQrCode();
  },
  beforeRouteLeave(to, form, next) {
    let accessToken = this.$session.get("access_token");
    if(accessToken !== null || WhiteList.indexOf(to.name) !== -1) {
      if(this.interval) clearInterval(this.interval);
      this.interval = null;
    }
    next();
  },
  methods: {
    getQrCode() {
      this.$axios({
        method : "get",
        url : "/api/account/web/login/qrcode",
      }).then(res => {
        if(res.status == 200 && res.data.status.code == 0) {
          this.code = res.data.result.code;
          this.qrcode = res.data.result.qrcode;

          this.verify();

          if(this.interval != null) return;
          this.interval = setInterval(() => {
            this.verify();
          }, 1000);
        }
      })
    },
    verify() {
      if(this.verifying) return;
      this.verifying = true;
      this.$axios({
        method : "post",
        url : "/api/account/web/login/verify",
        data: {code: this.code}
      }).then(res => {
        this.verifying = false;
        if(res.status == 200 && res.data.status.code == 0) {
          this.status = res.data.result.status;
          switch (this.status) {
            case 1:
              this.message = "等待授权";
              break;
            case 2:
              this.message = "登录成功";
              this.$message({
                message: '登录成功',
                type: 'success'
              });
              
              if(this.interval) clearInterval(this.interval);
              this.interval = null;
              this.$store.commit('receiveAccessToken', res.data.result.token);
              break;
            default:
              break;
          }
        } else {
          this.status = 3;
          this.message = "二维码已过期";
          if(this.interval) clearInterval(this.interval);
          this.interval = null;
        }
      })
    },
  },
  computed:{
    accessToken() {
      return this.$store.state.accessToken;
    },
  },
  watch: {
    accessToken(newVal) {
      if(newVal !== null) {
        if(this.$route.query.redirect != null && this.$route.query.redirect != "") {
          this.$router.replace(this.$route.query.redirect);
        } else {
          this.$router.replace({name: 'Info'})
        }
      }
    },
  }
}
</script>

<style lang="scss" scope>
@import '@/scss/public.scss';

.login {
  -webkit-box-flex: 1;
  background: $color-board;

  .login-center {
    display:-webkit-box; 
    background: $color-white;
    width: 627px;
    height: 400px;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, .2);

    .book {
      height: 100%;

      img {
        height: 100%;
      }
    }

    .qrcode {
      position: relative;
      width: 360px;
      height: 360px;
      
      .el-image {
        width: 360px;
        height: 360px;
      }

      .message-box {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;
        text-align: center;
        background: rgba(255, 255,255,.95);
        font-size: 22px;
        cursor: pointer;
        
        .in-message-box {
          padding: 150px 0px;
          line-height: 30px;
        }

        span, i {
          font-size: 12px;
        }
      }
    }

    .link {
      font-size: 14px;
      text-align: center;

      a {
        color: $color-type-transfer;
        text-decoration: none;
      }
    }
  }
}

</style>
